export async function setToken(item:any) {
    localStorage.setItem('session_token', JSON.stringify(item));
}

export async function getToken() {
   return await localStorage.getItem('session_token');
}